import { capitalize } from '@dhl/utils'

/* eslint-disable @typescript-eslint/no-explicit-any */
export const borders = (positions: ('top' | 'right' | 'bottom' | 'left')[], color: string) =>
  positions.reduce((acc, key) => ({ ...acc, [`border${capitalize(key)}`]: `1px solid ${color}` }), {} as any)
